import classNames from 'classnames'
import React from 'react'
import style from './styles/tag.module.scss'

interface IProps {
  title: string
  theme?: string
  size?: string
  className?: string
}

const Tag = ({
  title = '',
  theme = 'gray',
  size = 'medium',
  className = ''
}: IProps): React.ReactElement => {
  return (
    <span
      className={classNames({
        [style.tag]: true,
        [style[`theme_${theme}`]]: Boolean(theme),
        [style[`size_${size}`]]: Boolean(size),
        [className]: Boolean(className)
      })}
    >
      {title}
    </span>
  )
}

export default Tag
